import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function Edit2Icon(props: SvgIconProps) {
  const fill = props.fill ?? props.color ?? '#3B3C40';
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_107)'>
        <path
          d='M19 20H5C4.73478 20 4.48043 20.1054 4.29289 20.2929C4.10536 20.4804 4 20.7348 4 21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22H19C19.2652 22 19.5196 21.8946 19.7071 21.7071C19.8946 21.5196 20 21.2652 20 21C20 20.7348 19.8946 20.4804 19.7071 20.2929C19.5196 20.1054 19.2652 20 19 20Z'
          fill={fill}
        />
        <path
          d='M4.99981 18H5.08981L9.25981 17.62C9.71661 17.5745 10.1438 17.3732 10.4698 17.05L19.4698 8.04998C19.8191 7.68095 20.0079 7.18849 19.9948 6.68052C19.9817 6.17254 19.7677 5.69049 19.3998 5.33998L16.6598 2.59998C16.3022 2.26408 15.8336 2.07134 15.3431 2.05843C14.8527 2.04553 14.3746 2.21335 13.9998 2.52998L4.99981 11.53C4.67657 11.8559 4.47531 12.2832 4.42981 12.74L3.99981 16.91C3.98634 17.0564 4.00534 17.2041 4.05547 17.3424C4.1056 17.4806 4.18561 17.6062 4.28981 17.71C4.38325 17.8027 4.49406 17.876 4.6159 17.9258C4.73774 17.9755 4.8682 18.0007 4.99981 18ZM15.2698 3.99998L17.9998 6.72998L15.9998 8.67998L13.3198 5.99998L15.2698 3.99998ZM6.36981 12.91L11.9998 7.31998L14.6998 10.02L9.09981 15.62L6.09981 15.9L6.36981 12.91Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_107'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
